import { render, staticRenderFns } from "./sendInfo.vue?vue&type=template&id=0b251cb6&scoped=true&"
import script from "./sendInfo.vue?vue&type=script&lang=js&"
export * from "./sendInfo.vue?vue&type=script&lang=js&"
import style0 from "./sendInfo.vue?vue&type=style&index=0&id=0b251cb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b251cb6",
  null
  
)

export default component.exports